export default "__VITE_ASSET__BapZ4S3U__"